<template>
  <div class="ele-input" :style="{ 'align-items': verticalAlign }">
    <InputLabel v-if="label" :text="label" :required="required" />
    <el-input
      v-bind="$attrs"
      v-on="$listeners"
    >
      <!-- 带icon输入框 -->
      <slot name="prefix" slot="prefix"></slot>
      <slot name="suffix" slot="suffix"></slot>
      <!-- 复合型输入框 -->
      <slot name="prepend" slot="prepend"></slot>
      <slot name="append" slot="append"></slot>
      <!-- <span slot="prepend" v-if="prepend">{{ prepend }}</span>
      <span slot="append" v-if="append">{{ append }}</span> -->
    </el-input>
  </div>
</template>

<script>
  import InputLabel from "./InputLabel";
  // 设置输入框的宽度
  import { inputMixin } from "./mixin/inputMixin";
  export default {
    name: "EleInput",
    mixins: [inputMixin],
    components: {
      InputLabel,
    },
    props: {
      required: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
      },
      // // iview官方api没有该props，可代替 slot prepend 使用
      // prepend: {
      //   type: String,
      // },
      // // iview官方api没有该props，可代替 slot append 使用
      // append: {
      //   type: String,
      // },
      /**
       * 标签垂直对齐方式，通常是textarea输入框时标签需要置于输入框顶部
       * 可选：top、bottom、center（默认）
       */
      labelVerticalAlign: {
        type: String,
      },
    },
    computed: {
      // label垂直对齐方式，默认是center
      verticalAlign() {
        switch (this.labelVerticalAlign) {
          case "top":
            return "flex-start";
          case "bottom":
            return "flex-end";
          case "center":
            return "center";
          default:
            return this.type === "textarea" ? "flex-start" : "center";
        }
      },
    },
    data() {
      return {
      };
    },
  };
</script>

<style lang="less" scoped>
  .ele-input {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;

    /deep/.el-input {
      width: 290px;
      height: 36px;

      input {
        width: 100%;
        height: 100%;
        background: linear-gradient(0deg, rgba(0,197,250,0.5) 0%, rgba(0,197,250,0.48) 6%, rgba(0,197,250,0.11) 100%);
        outline: none;
        border: none;
        color: #fff;
        font-size: 14px;
      }
    }
  }
  // 定好宽度
  .input-long {
    width: 400px;
  }
  .input-middle {
    width: 240px;
  }
  .input-short {
    width: 120px;
  }
</style>

<docs>
  ```vue
  <template>
    <ElementInput label="可以清除" placeholder="可以随意提示" clearable @clear="clearInput" v-model="input1"/>
    <ElementInput label="可以禁止" placeholder="可以随意提示" v-model="input1" disabled/>
    <ElementInput label="密码哦" required placeholder="密码" v-model="input2" show-password/>
    <ElementInput label="属性方式带入icon后面" required placeholder="icon" v-model="input2" suffix-icon="el-icon-date"/>
    <ElementInput label="属性方式带入icon前面" required placeholder="icon" v-model="input2" prefix-icon="el-icon-date"/>
    <ElementInput label="插槽方式带入icon前面" required placeholder="icon" v-model="input2" >
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </ElementInput>
    <ElementInput label="插槽方式带入icon后面" required placeholder="icon" v-model="input2" >
      <i slot="suffix" class="el-input__icon el-icon-date"></i>
    </ElementInput>
    <ElementInput label="文本域" placeholder="可以随意提示" v-model="input2" type="textarea" :rows="12"/>
    <ElementInput label="文本域自适应" placeholder="可以随意提示" v-model="input2" type="textarea" autosize/>
    <ElementInput label="文本域定制" placeholder="可以随意提示" v-model="input2" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"/>
    <ElementInput label="复合型输入框前" placeholder="可以随意提示" v-model="input2" >
      <template slot="prepend">Http://</template>
    </ElementInput>
    <ElementInput label="复合型输入框后" placeholder="可以随意提示" v-model="input2" >
      <template slot="append">.com</template>
    </ElementInput>
    <ElementInput label="复合型输入框自定义" placeholder="自定义" v-model="input2" >
      <!-- 下拉框 -->
      <el-select v-model="select" slot="prepend" placeholder="请选择">
        <el-option label="餐厅名" value="1"></el-option>
        <el-option label="订单号" value="2"></el-option>
        <el-option label="用户电话" value="3"></el-option>
      </el-select>
      <!-- 按钮 -->
      <el-button slot="append" icon="el-icon-search"></el-button>
    </ElementInput>
    <ElementInput label="inputWidth控制宽度。默认240px" placeholder="可以随意提示" v-model="input2" size="mini" :inputWidth="'long'" />
    <ElementInput label="show-word-limit" placeholder="可以随意提示" v-model="input2" type="textarea" :rows="2" maxlength="10" show-word-limit />
    <ElementInput label="resize" placeholder="可以随意提示" v-model="input2" type="textarea" :rows="2" maxlength="10" resize="none" />
    <ElementInput label="labelVerticalAlign位置" placeholder="可以随意提示" v-model="input2" type="textarea" :rows="12" :labelVerticalAlign="'bottom'" />
    <ElementInput label="maxlength" placeholder="可以随意提示" v-model="input2" maxlength="5" />
    <ElementInput label="minlength" placeholder="可以随意提示" v-model="input2" minlength="2" />
    <ElementInput label="change事件" placeholder="可以随意提示" v-model="input2" @change="changeInput" />
    <ElementInput label="input事件" placeholder="可以随意提示" v-model="input2" @input="inputInput" />
  </template>

  <script>
    export default {
      data() {
        return {
          input1: "111",
          input2: "",
          select: "",
        };
      },
      methods: {
        // input
        changeInput(v) {
          console.log(v);
        },
        inputInput(v) {
          console.log(v);
        },
        clearInput(v) {
          console.log(v,'已经清除');
        }
      },
    };
  </script>

  <style lang="less">
    // 给复合框自定义前的select的样式
    .el-select .el-input {
      width: 130px;
    }
    .input-with-select .el-input-group__prepend {
      background-color: #fff;
    }
  </style>
  ```
</docs>
